<template>
  <header class="header-wrapper w-full top-0 left-0 absolute">
    <div class="wrapper max-w-1440px ml-auto mr-auto">
      <div class="header-content-flex flex justify-between items-center">
        <div class="left z-10">
          <Logo :imgsrc="logoIcon" />
        </div>
        <div class="right">
          <button
            :class="{'active':isMenuVisible}"
            @click="menuToggle"
            class="xl:hidden z-10 lg:hidden md:flex mobile-menu-toggle relative w-spc34 h-5 flex flex-col justify-between items-center cursor-pointer"
          >
            <span class="bg-white line-1 h-spc11 w-full"></span>
            <span class="bg-white line-2 h-spc11 w-full"></span>
            <span class="bg-white line-3 h-spc11 w-full"></span>
          </button>
          <Navbar />
          <div
            v-show="isMenuVisible"
            class="header-mobile-menu pt-spc39 w-full h-full fixed top-0 left-0 xl:hidden lg:block hidden md:block"
          >
            <MobileMenu />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Navbar from "./Navbar";
import Logo from "./Logo";
import $ from "jquery";
import MobileMenu from "./MobileMenu";

export default {
  name: "ThemeHeader",
  components: {
    MobileMenu,
    Logo,
    Navbar
  },
  data() {
    return {
      logoIcon: require("@/assets/images/logo.svg"),
      isMenuVisible: false
    };
  },
  methods: {
    menuToggle() {
      this.isMenuVisible = !this.isMenuVisible;
    }
  },
  mounted() {
    $(window).scroll(function() {
      if ($(window).scrollTop() >= 800) {
        $("body").addClass("fixed-header");
      } else {
        $("body").removeClass("fixed-header");
      }
    });
  }
};
</script>

<style scoped>
</style>